import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../endpoints';
import { FileWithUrl } from '../../documents';

export interface FormResponseDocument {
    _id: string;
    responseId: string;
    documentId: string;
    createdAt: string;
    updatedAt: string;
    file?: FileWithUrl;
}

export interface FormResponseDocumentsResponse {
    message: string;
    data: FormResponseDocument[];
}

export interface FormResponseDocumentResponse {
    message: string;
    data: FormResponseDocument;
}

// CREATE
export const createFormResponseDocument = async (responseId: string, file: File): Promise<FormResponseDocumentResponse> => {
    try {
        const formData = new FormData();
        formData.append('responseId', responseId);
        formData.append('file', file);

        const response: AxiosResponse<FormResponseDocumentResponse> = await apiClient.post('/form-response-documents', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DELETE
export const deleteFormResponseDocument = async (id: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/form-response-documents/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// GET BY RESPONSE ID
export const getDocumentsByResponseId = async (responseId: string): Promise<FormResponseDocumentsResponse> => {
    try {
        const response: AxiosResponse<FormResponseDocumentsResponse> = await apiClient.get(`/form-response-documents/${responseId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
